import React from 'react';
// import PropTypes from 'prop-types';

import { getComponentsByType, getDataByType } from '../../../utils/utils';
import { NavigationBar } from '../../organisms/shared/navigationBar/NavigationBar';
import Header from '../../organisms/shared/header/Header';
import CounterSection from '../../organisms/home/counterSection/CounterSection';
import SystemGuideOverview from '../../organisms/home/systemGuideOverview/SystemGuideOverview';
import Ratings from '../../organisms/home/ratings/Ratings';
import CompareSection from '../../organisms/home/compareSection/CompareSection';
import DigitalTools from '../../organisms/home/digitalTools/DigitalTools';
import Footer from '../../organisms/shared/footer/Footer';
import Testimonials from '../../organisms/shared/testimonials/Testimonials';
import PopularCategories from '../../organisms/shared/popularCategories/PopularCategories';
import SystemGuideCard from '../../molecules/home/systemGuideCard/SystemGuideCard';

export const Home = ({
  hero,
  sections,
  t,
  locale,
  menu,
  footer,
  siteUrls,
  location,
  search,
  searchBig,
}) => {
  const popularSection = getDataByType(sections, 'popularCategories');
  const counterSection = getDataByType(sections, 'siteResults');
  const testimonialsSection = getDataByType(sections, 'testimonials');
  const guideSections = getComponentsByType(sections, 'guideSections');
  const ratingSection = getComponentsByType(sections, 'reviews');
  const compareSection = getComponentsByType(sections, 'compare');
  const digitalSection = getDataByType(sections, 'digitalServices');

  return (
    <div className="bg-primary-50 overflow-x-hidden">
      <NavigationBar
        data={menu}
        location={location}
        locale={locale}
        search={search}
        t={t}
      />
      <Header
        // title={hero.label}
        headerText={hero.title}
        headerDescription={hero.description}
        card={
          <SystemGuideCard
            heading={hero.ctaSystemGuide.title}
            text={hero.ctaSystemGuide.text}
            buttonText={hero.ctaSystemGuide.buttonText}
            buttonHref={hero.ctaSystemGuide.buttonHref}
          />
        }
        t={t}
        search={searchBig}
      />
      <main className="relative">
        <PopularCategories section={popularSection} t={t} />
        <CounterSection section={counterSection} />
        <Testimonials
          section={testimonialsSection}
          locale={locale}
          withStyledBg
        />
        <SystemGuideOverview sections={guideSections} />
        <Ratings sections={ratingSection} />
        <CompareSection sections={compareSection} />
        <DigitalTools section={digitalSection} />
      </main>
      <Footer data={footer} siteUrls={siteUrls} />
    </div>
  );
};

Home.propTypes = {
  // heading1: PropTypes.string,
  // hero: PropTypes.object,
  // cta2: PropTypes.object,
  // sections: PropTypes.array,
  // testimonials: PropTypes.array,
  // ratings: PropTypes.object,
  // compare: PropTypes.object,
  // servicetools: PropTypes.array,
};
